import List from '@/pages/admin/users/List.vue';
import Show from '@/pages/admin/users/Show.vue';
import handleActivePaginationRouteProps from '@/utils/handleActivePaginationRouteProps.js';

export default [
  {
    path: 'users',
    name: 'users',
    component: List,
    props: handleActivePaginationRouteProps,
  },
  {
    path: 'users/:id(\\d+)',
    name: 'user',
    component: Show,
  },
];
